module.exports = __webpack_public_path__ + "static/Aston-20182_b3noqk-a965acd88390875eaa703082e6e2c266.jpg";